// src/Components/Launch/hooks/useLaunchDrawers.js
import { useState } from 'react';
import { createApiUrl } from '../../../Config/apiConfig';

const useLaunchDrawers = () => {
    const [dialog, setDialog] = useState(false);
    const [gameDetailsOpen, setGameDetailsOpen] = useState(false);
    const [serverExplorerOpen, setServerExplorerOpen] = useState(false);
    const [gameData, setGameData] = useState(null);

    const toggleDrawer = (open) => {
        setDialog(open);
    };

    const toggleServerExplorer = (open) => {
        setServerExplorerOpen(open);
    };

    const toggleGameDetailsDrawer = async (open, launchID) => {
        if (open && launchID) {
            await fetchGameData(launchID);
        }
        setGameDetailsOpen(open);
    };

    const fetchGameData = async (payoutVariantName) => {
        try {
            const response = await fetch(
                createApiUrl(`GTP/game?payoutVariantName=${payoutVariantName}`)
            );
            if (!response.ok) throw new Error('Failed to fetch game data');
            const data = await response.json();
            setGameData(data);
        } catch (error) {
            console.error('Error fetching game data:', error);
        }
    };

    return {
        dialog,
        gameDetailsOpen,
        serverExplorerOpen,
        gameData,
        toggleDrawer,
        toggleServerExplorer,
        toggleGameDetailsDrawer
    };
};

export default useLaunchDrawers;